import {Locales} from "../../../localization/types";

export const getData = (locale: Locales) => {
  if (locale === 'ru-BY') {
    return {
      title: 'Тарифы',
      periods: [
        {
          label: 'Год',
          name: 'year',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 660,
              //priceFull: 900,
              currency: ' BYN',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 900,
              //priceFull: 1320,
              currency: ' BYN',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования',
              price: 1200,
              //priceFull: 2040,
              popular: true,
              currency: ' BYN',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 1800,
              //priceFull: 2600,
              currency: ' BYN',
            },
          ],
        },
        {
          label: 'Месяц',
          name: 'month',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 66,
              currency: ' BYN',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 85,
              currency: ' BYN',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования',
              price: 110,
              popular: true,
              currency: ' BYN',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 170,
              currency: ' BYN',
            },
          ],
        },
      ],
    }
  }

  if (locale === 'kz-KZ') {
    return {
      title: 'Тарифтер',
      periods: [
        {
          label: 'Жылы',
          name: 'year',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Жылдам сатуға арналған құралдар',
              price: 70800,
              //priceFull: 900,
              currency: ' ₸',
              button: 'Бастау'
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Жаңа аудиторияны ұстап қалу құралдары',
              price: 170000,
              //priceFull: 204000,
              currency: ' ₸',
              button: 'Бастау'
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Дамыту және масштабтау жүйесі',
              price: 225000,
              //priceFull: 270000,
              popular: true,
              currency: ' ₸',
              button: 'Бастау'
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Терең аналитика және қаржы модульдері',
              price: 285000,
              //priceFull: 342000,
              currency: ' ₸',
              button: 'Бастау'
            },
          ],
        },
        {
          label: 'Айы',
          name: 'month',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Жылдам сатуға арналған құралдар',
              price: 9000,
              //priceFull: 900,
              currency: ' ₸',
              button: 'Бастау'
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Жаңа аудиторияны ұстап қалу құралдары',
              price: 17000,
              currency: ' ₸',
              button: 'Бастау'
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Дамыту және масштабтау жүйесі',
              price: 22500,
              popular: true,
              currency: ' ₸',
              button: 'Бастау'
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Терең аналитика және қаржы модульдері',
              price: 28500,
              currency: ' ₸',
              button: 'Бастау'
            },
          ],
        },
      ],
    }
  }

  if (locale === 'ru-KZ') {
    return {
      title: 'Тарифы',
      periods: [
        {
          label: 'Год',
          name: 'year',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 70800,
              //priceFull: 900,
              currency: ' ₸',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 170000,
              //priceFull: 204000,
              currency: ' ₸',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования ',
              price: 225000,
              //priceFull: 270000,
              popular: true,
              currency: ' ₸',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 285000,
              //priceFull: 342000,
              currency: ' ₸',
            },
          ],
        },
        {
          label: 'Месяц',
          name: 'month',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 9000,
              //priceFull: 900,
              currency: ' ₸',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 17000,
              currency: ' ₸',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования ',
              price: 22500,
              popular: true,
              currency: ' ₸',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 28500,
              currency: ' ₸',
            },
          ],
        },
      ],
    }
  }

  return {
    title: 'Тарифы',
    periods: [
      {
        label: 'Месяц',
        name: 'month',
        items: [
          {
            name: 'Касса',
            code: 'cashier',
            color: 'green',
            description: 'Всё самое необходимое для управления бизнесом.',
            price: 2490,
          },
          {
            name: 'Смарт',
            code: 'smart',
            color: 'blueOcean',
            description: 'Спроектирован для роста вашей прибыли.',
            price: 3990,
          },
          {
            name: 'Про',
            code: 'pro',
            color: 'fuchsia',
            description: 'Для управления проектами на самом высоком уровне.',
            price: 5990,
            popular: true,
          },
        ],
      },
      {
        label: '6 месяцев',
        name: 'month6',
        items: [
          {
            name: 'Касса',
            code: 'cashier',
            color: 'green',
            description: 'Всё самое необходимое для управления бизнесом.',
            price: 2248,
            priceFull: 2490,
            amountPrice: 13490,
            discount: "10%"
          },
          {
            name: 'Смарт',
            code: 'smart',
            color: 'blueOcean',
            description: 'Спроектирован для роста вашей прибыли.',
            price: 3582,
            priceFull: 3990,
            amountPrice: 21490,
            discount: "10%"
          },
          {
            name: 'Про',
            code: 'pro',
            color: 'fuchsia',
            description: 'Для управления проектами на самом высоком уровне.',
            price: 5415,
            priceFull: 5990,
            amountPrice: 32490,
            discount: "10%",
            popular: true,
          },
        ],
      },
      {
        label: 'Год',
        name: 'year',
        items: [
          {
            name: 'Касса',
            code: 'cashier',
            color: 'green',
            description: 'Всё самое необходимое для управления бизнесом.',
            price: 2075,
            priceFull: 2490,
            amountPrice: 24900,
            discount: "20%",
          },
          {
            name: 'Смарт',
            code: 'smart',
            color: 'blueOcean',
            description: 'Спроектирован для роста вашей прибыли.',
            price: 3325,
            priceFull: 3990,
            amountPrice: 39900,
            discount: "20%",
          },
          {
            name: 'Про',
            code: 'pro',
            color: 'fuchsia',
            description: 'Для управления проектами на самом высоком уровне.',
            price: 4990,
            priceFull: 5990,
            amountPrice: 59880,
            discount: "20%",
            popular: true,
          },
        ],
      },
    ],
  }
}
